import { DEV } from "solid-js";
import { isNil } from "lodash-es";

type DeploymentEnv =
  | "production" // Production servers
  | "development" // Development servers
  | "local"; // Developer machine

const VALID_ENVS: readonly DeploymentEnv[] = ["production", "development", "local"] as const;

const resolveDeployment = (val?: string): DeploymentEnv => {
  if (!isNil(DEV)) {
    return "local";
  }

  const v = val?.trim().toLowerCase();
  if (VALID_ENVS.includes(v as DeploymentEnv)) {
    return v as DeploymentEnv;
  }

  throw new Error("Failed to resolve deployment environment");
};

const deployment = resolveDeployment(import.meta.env.VITE_APP_ENV);

// Convenience flags
const isLocal = () => deployment === "local";
const isStorybook = () => Boolean(import.meta.env.STORYBOOK);
const isDevelopment = () => deployment === "development";
const isProduction = () => deployment === "production";
const isLive = () => isDevelopment() || isProduction();

const environment = Object.freeze({
  origin: window.location.origin,
  deployment,
  isLocal,
  isStorybook,
  isDevelopment,
  isProduction,
  isLive,
});

export default environment;
